"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var asg_1 = require("@alinta-digital/asg");
var formik_1 = require("formik");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var lodash_1 = (0, tslib_1.__importDefault)(require("lodash"));
var SavedPaymentTile_types_1 = require("../SavedPaymentTile/SavedPaymentTile.types");
var SavedPaymentTile_1 = (0, tslib_1.__importStar)(require("../SavedPaymentTile/SavedPaymentTile"));
var BankDetails_1 = (0, tslib_1.__importDefault)(require("./BankDetails"));
var BankDetailsWithSavedPayment = function (_a) {
    var _b = _a.sectionKey, secKey = _b === void 0 ? '' : _b, customerNumber = _a.customerNumber, onChange = _a.onChange, displayHeaderTitle = _a.displayHeaderTitle;
    var sectionKey = secKey ? secKey + "." : secKey;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _c = (0, react_1.useState)(true), savePaymentsLoading = _c[0], setSavedPaymentLoading = _c[1];
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var _d = (0, react_1.useState)(false), hasSavedPaymentTileError = _d[0], setSavedPaymentTileError = _d[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ctx = (0, formik_1.useFormikContext)();
    var clearBsbValidationFields = function () {
        ctx.setFieldValue(sectionKey + "isBsbValid", false);
        ctx.setFieldValue(sectionKey + "bank", '');
        ctx.setFieldValue(sectionKey + "branch", '');
    };
    var clearBankDataFields = function () {
        clearBsbValidationFields();
        ctx.setFieldValue(sectionKey + "bsb", '');
        ctx.setFieldValue(sectionKey + "accountName", '');
        ctx.setFieldValue(sectionKey + "accountNumber", '');
        ctx.setFieldValue(sectionKey + "isAuthorised", false);
        ctx.setFieldValue(sectionKey + "savedPaymentId", '');
    };
    var savedPaymentIdVal = lodash_1.default.get(ctx.values, sectionKey + "savedPaymentId");
    var hasBankDataAndIsValid = lodash_1.default.get(ctx.values, sectionKey + "bsb") &&
        lodash_1.default.get(ctx.values, sectionKey + "bank") &&
        lodash_1.default.get(ctx.values, sectionKey + "branch") &&
        lodash_1.default.get(ctx.values, sectionKey + "isBsbValid");
    var _e = (0, react_1.useState)(savedPaymentIdVal ? savedPaymentIdVal : hasBankDataAndIsValid ? SavedPaymentTile_1.ADD_NEW : ''), selectedAccount = _e[0], setSelectedAccount = _e[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !hasSavedPaymentTileError && (react_1.default.createElement(asg_1.Box, { margin: {
                bottom: responsiveSize === 'xs' ? 'xsmall' : 'large'
            }, "data-testid": "bankAccountdetail-card" },
            react_1.default.createElement(SavedPaymentTile_1.default, { radioGroupName: sectionKey + "savedPaymentId", customerNumber: customerNumber, paymentFilter: SavedPaymentTile_types_1.SavedPaymentType.BANKACCOUNT, selectedAccountId: selectedAccount, onError: function () {
                    setSelectedAccount(SavedPaymentTile_1.ADD_NEW);
                    setSavedPaymentTileError(true);
                }, onChange: function (selectedOption, data) {
                    setSelectedAccount(selectedOption);
                    !hasSavedPaymentTileError && clearBankDataFields();
                    onChange(data);
                    if (selectedOption !== SavedPaymentTile_1.ADD_NEW)
                        ctx.setFieldValue(sectionKey + "savedPaymentId", data === null || data === void 0 ? void 0 : data.savedPaymentId);
                }, displayHeaderTitle: displayHeaderTitle, setLoading: setSavedPaymentLoading }))),
        selectedAccount === SavedPaymentTile_1.ADD_NEW && (react_1.default.createElement(formik_1.FormikProvider, { value: ctx },
            react_1.default.createElement(BankDetails_1.default, { sectionKey: secKey })))));
};
exports.default = BankDetailsWithSavedPayment;
//# sourceMappingURL=BankDetailsWithSavedPayment.js.map